// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_QvZNl {
  display: flex;
  justify-content: space-between;
  width: 94%;
  background-color: white;
  z-index: 5;
  position: relative;
}

.headerMail_dfxUg {
  display: flex;
  align-items: center;
  justify-content: start;
}

.iconContainer_re3zs {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--d9-background);
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  height: 27px;
  width: 30px;
}

.addConnection_gaAF6 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;

  p {
    color: var(--9ca3af-color);
    cursor: pointer;
    min-height: 20px;
    &.active_ZzfUr {

      color: #159b7c;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/HeadersFormsComponent/HeaderFormsComponent.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,UAAU;EACV,uBAAuB;EACvB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;;EAET;IACE,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB;;MAEE,cAAc;IAChB;EACF;AACF","sourcesContent":[".header {\n  display: flex;\n  justify-content: space-between;\n  width: 94%;\n  background-color: white;\n  z-index: 5;\n  position: relative;\n}\n\n.headerMail {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n}\n\n.iconContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--d9-background);\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n  height: 27px;\n  width: 30px;\n}\n\n.addConnection {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 18px;\n\n  p {\n    color: var(--9ca3af-color);\n    cursor: pointer;\n    min-height: 20px;\n    &.active {\n\n      color: #159b7c;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `header_QvZNl`,
	"headerMail": `headerMail_dfxUg`,
	"iconContainer": `iconContainer_re3zs`,
	"addConnection": `addConnection_gaAF6`,
	"active": `active_ZzfUr`
};
export default ___CSS_LOADER_EXPORT___;
